var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsIndeterminateCheckBoxRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 21.6667H26.6667C27.1389 21.6667 27.535 21.5067 27.855 21.1867C28.175 20.8667 28.3344 20.4711 28.3333 20C28.3322 19.5289 28.1722 19.1333 27.8533 18.8133C27.5344 18.4933 27.1389 18.3333 26.6667 18.3333H13.3333C12.8611 18.3333 12.4656 18.4933 12.1467 18.8133C11.8278 19.1333 11.6678 19.5289 11.6667 20C11.6656 20.4711 11.8256 20.8672 12.1467 21.1883C12.4678 21.5094 12.8633 21.6689 13.3333 21.6667ZM8.33333 35C7.41667 35 6.63222 34.6739 5.98 34.0217C5.32778 33.3694 5.00111 32.5844 5 31.6667V8.33333C5 7.41667 5.32667 6.63222 5.98 5.98C6.63333 5.32778 7.41778 5.00111 8.33333 5H31.6667C32.5833 5 33.3683 5.32667 34.0217 5.98C34.675 6.63333 35.0011 7.41778 35 8.33333V31.6667C35 32.5833 34.6739 33.3683 34.0217 34.0217C33.3694 34.675 32.5844 35.0011 31.6667 35H8.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsIndeterminateCheckBoxRounded);
export default __webpack_public_path__ + "static/media/material-symbols_indeterminate-check-box-rounded.1ca1cee96aee1fbf62ba28745fa035f6.svg";
export { ForwardRef as ReactComponent };